export default "__VITE_ASSET__BLyICA27__"